"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractViews = void 0;
var isObjectLike_1 = __importDefault(require("lodash/isObjectLike"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var values_1 = __importDefault(require("lodash/values"));
var flattenDeep_1 = __importDefault(require("lodash/flattenDeep"));
var isView_1 = require("./isView");
var extractViews = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = (0, flattenDeep_1.default)(args);
    result = result.map(function (x) {
        if ((0, isView_1.isView)(x)) {
            return x;
        }
        else if ((0, isObjectLike_1.default)(x)) {
            return (0, values_1.default)(x).map(function (y) {
                if ((0, isView_1.isView)(y)) {
                    return y;
                }
                else {
                    return (0, exports.extractViews)(y);
                }
            });
        }
    });
    result = (0, flattenDeep_1.default)(result);
    result = result.filter(isView_1.isView);
    result = (0, uniqBy_1.default)(result, "buildId");
    return result;
};
exports.extractViews = extractViews;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmFjdFZpZXdzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2V4dHJhY3RWaWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFDQSxxRUFBK0M7QUFDL0MseURBQW1DO0FBQ25DLHlEQUFtQztBQUNuQyxtRUFBNkM7QUFDN0MsbUNBQWtDO0FBRTNCLElBQU0sWUFBWSxHQUFHO0lBQUMsY0FBa0I7U0FBbEIsVUFBa0IsRUFBbEIscUJBQWtCLEVBQWxCLElBQWtCO1FBQWxCLHlCQUFrQjs7SUFDN0MsSUFBSSxNQUFNLEdBQWMsSUFBQSxxQkFBVyxFQUFDLElBQUksQ0FBQyxDQUFDO0lBRTFDLE1BQU0sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQUMsQ0FBQztRQUNwQixJQUFJLElBQUEsZUFBTSxFQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2IsT0FBTyxDQUFDLENBQUM7U0FDVjthQUFNLElBQUksSUFBQSxzQkFBWSxFQUFDLENBQUMsQ0FBQyxFQUFFO1lBQzFCLE9BQU8sSUFBQSxnQkFBTSxFQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFDLENBQUM7Z0JBQ3JCLElBQUksSUFBQSxlQUFNLEVBQUMsQ0FBQyxDQUFDLEVBQUU7b0JBQ2IsT0FBTyxDQUFDLENBQUM7aUJBQ1Y7cUJBQU07b0JBQ0wsT0FBTyxJQUFBLG9CQUFZLEVBQUMsQ0FBQyxDQUFDLENBQUM7aUJBQ3hCO1lBQ0gsQ0FBQyxDQUFDLENBQUM7U0FDSjtJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsTUFBTSxHQUFHLElBQUEscUJBQVcsRUFBQyxNQUFNLENBQUMsQ0FBQztJQUM3QixNQUFNLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxlQUFNLENBQUMsQ0FBQztJQUMvQixNQUFNLEdBQUcsSUFBQSxnQkFBTSxFQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsQ0FBQztJQUVuQyxPQUFPLE1BQWdCLENBQUM7QUFDMUIsQ0FBQyxDQUFDO0FBdEJXLFFBQUEsWUFBWSxnQkFzQnZCIn0=